import { render, staticRenderFns } from "./MainCarrousel.vue?vue&type=template&id=3690eafe&scoped=true&"
import script from "./MainCarrousel.vue?vue&type=script&lang=ts&"
export * from "./MainCarrousel.vue?vue&type=script&lang=ts&"
import style0 from "./MainCarrousel.vue?vue&type=style&index=0&id=3690eafe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3690eafe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCarousel,VCarouselItem,VCol,VLayout,VRow})
